import React from 'react';

class Dropdown extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { cssForDropdown, idName, onChangeValue, onChangeComponent, onFocusName, DropdownKeyValuePair, onFocusChange, disabledField } = this.props;
        {//console.log(disabledField)
        }
        return (
            <>
                <select className={cssForDropdown}
                    id={idName}
                    name={idName}
                    value={onChangeComponent}
                    onChange={onChangeValue}
                    onFocus={() => onFocusChange(onFocusName)} 
                    onClick={() => onFocusChange(onFocusName)}
                    disabled = {disabledField}
                >
                    {DropdownKeyValuePair.map(item => (
                    <option key={item.Key}  value={item.Key}>
                        {item.Value}
                    </option>
                    ))}
                </select>
            </>
        );
    }
}

export default Dropdown